import React, { useEffect } from 'react';
import type { FC } from 'react';
import { render, useExit } from '@wix/cli-ui-kit';
import { BiProvider } from '@wix/cli-telemetry-react';
import type { BiLogger } from '@wix/cli-telemetry';
import { ErrorReporterProvider } from '@wix/cli-error-reporting';
import type { ErrorReporter } from '@wix/cli-error-reporting';
import type { LoginMode } from '@wix/cli-core-definitions';
import type { AuthState } from './context.js';
import { LoginModeProvider } from './login-mode.js';
import { SiteAuthProvider } from './providers/SiteAuthProvider.js';
import { useAuth } from './useAuth.js';

const Wrapper: FC<{ onReady: (data: AuthState) => void }> = ({ onReady }) => {
  const exit = useExit();
  const auth = useAuth();

  useEffect(() => {
    onReady(auth);
    exit();
  }, [exit, auth, onReady]);

  return null;
};

/**
 * @deprecated migrate to ink & use `SiteAuthProvider` directly
 */
export function authenticateWithSiteId(
  siteId: string,
  biLogger: BiLogger,
  errorReporter: ErrorReporter,
  loginMode?: LoginMode
): Promise<AuthState> {
  return new Promise<AuthState>((resolve, reject) => {
    render(
      <ErrorReporterProvider value={errorReporter}>
        <BiProvider value={biLogger}>
          <LoginModeProvider value={loginMode}>
            <SiteAuthProvider siteId={siteId}>
              <Wrapper onReady={resolve} />
            </SiteAuthProvider>
          </LoginModeProvider>
        </BiProvider>
      </ErrorReporterProvider>
    ).catch((error: unknown) => reject(error));
  });
}
